import { Injectable } from '@angular/core';
import { ParceiroNegocio } from 'app/interfaces/parceiro-negocio';
import { Usuario } from 'app/interfaces/usuario';


@Injectable({
  providedIn: 'root'
})
export class UsuarioAddService {
  constructor() { 
  }

  construirObjetoDoForm(parceiroNegocio: ParceiroNegocio) {
    return {
      nome: parceiroNegocio.nome.trim(),
      produtos: parceiroNegocio.produtos,
      ativo: parceiroNegocio.ativo,
      grupo: { grpId: parceiroNegocio.grupoId },
      empresa: { empId: 1 }
    } as Usuario;
  }
}
